export default __webpack_public_path__ + "static/media/journals_light.85c1802c.png";